document.addEventListener('DOMContentLoaded', () => {
  const quickAddDrawer = document.getElementById('QuickAddDrawer');
  const cartDrawer = document.getElementById('CartDrawer');
  
  if (!quickAddDrawer || !cartDrawer) return;

  const quickAddInner = quickAddDrawer.querySelector('.quick-add-drawer__inner');
  const quickAddLoading = quickAddDrawer.querySelector('.quick-add-drawer__loading');
  
  const cartBody = document.getElementById('CartDrawerBody');
  const cartFooter = document.getElementById('CartDrawerFooter');
  const cartTotal = document.getElementById('CartDrawerTotal');

  // --- Drawer Toggles ---
  function openQuickAdd() {
    quickAddDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeQuickAdd() {
    quickAddDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  
  function openCart() {
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Close triggers
  document.querySelectorAll('[data-quick-add-close]').forEach(el => el.addEventListener('click', closeQuickAdd));
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));

  // --- Quick Add Logic ---
  document.body.addEventListener('click', (e) => {
    // Open Quick Add Drawer
    const trigger = e.target.closest('[data-quick-add]');
    if (trigger) {
      e.preventDefault();
      const handle = trigger.dataset.quickAdd;
      if (!handle) return;
      
      quickAddInner.innerHTML = '';
      quickAddLoading.style.display = 'block';
      openQuickAdd();

      // 商品データと「表示バッジ」の判定結果（LIMITED STOCK の色・サイズ、手動 SOLD OUT）を同時に取得
      // （判定は templates/product.stock-data.liquid → snippets/rell-badges.liquid / rell-low-stock.liquid）
      const stockReq = fetch(`/products/${handle}?view=stock-data`)
        .then(res => (res.ok ? res.text() : '{}'))
        .then(text => { try { return JSON.parse(text); } catch (e) { return {}; } })
        .catch(() => ({}));

      Promise.all([fetch(`/products/${handle}.js`).then(res => res.json()), stockReq])
        .then(([product, stock]) => {
          quickAddLoading.style.display = 'none';
          renderQuickAddProduct(product, stock);
        })
        .catch(err => {
          console.error(err);
          quickAddLoading.style.display = 'none';
          quickAddInner.innerHTML = '<p style="text-align:center;">商品の読み込みに失敗しました。</p>';
        });
    }

    // Open Cart Drawer Trigger (if any icon has data-cart-trigger)
    const cartTrigger = e.target.closest('[data-cart-trigger]');
    if (cartTrigger) {
      e.preventDefault();
      openCart();
    }
  });

  const moneyFormat = (cents) => `￥${(cents/100).toLocaleString()}`;

  function renderQuickAddProduct(product, stock) {
    // LIMITED STOCK の色・サイズID（取得に失敗したら空＝「在庫あり」表示）
    const lowIds = new Set(((stock && stock.low) || []).map(String));
    // 表示バッジで SOLD OUT を選んだ商品は、在庫があっても全て SOLD OUT 扱い（カートに入れられない）
    const forceSoldOut = !!(stock && stock.soldout);

    let colorOptionIndex = -1;
    let sizeOptionIndex = -1;

    product.options.forEach(opt => {
      const name = opt.name.toLowerCase();
      if (name === 'color' || name === 'colour' || name === 'カラー' || name === '色') {
        colorOptionIndex = opt.position;
      } else if (name === 'size' || name === 'サイズ') {
        sizeOptionIndex = opt.position;
      }
    });

    const price = moneyFormat(product.price);
    
    // バリアント単位のウィッシュリスト状態を取得
    const currentWishlist = typeof window.getWishlist === 'function' ? window.getWishlist() : [];

    let html = `
      <div class="quick-add-product-info">
        <h3 class="quick-add-product-name">${product.title}</h3>
        <p class="quick-add-product-price">${price}</p>
      </div>
    `;

    const heartSvg = `<svg width="21" height="19" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 20.25C12 20.25 1.5 14.25 1.5 7.5C1.5 6.10761 2.05312 4.77226 3.03769 3.78769C4.02226 2.80312 5.35761 2.25 6.75 2.25C8.51513 2.25 10.0744 3.10406 11.0234 4.42969C11.2687 4.77759 11.6208 5.00016 12 5.00016C12.3792 5.00016 12.7313 4.77759 12.9766 4.42969C13.9256 3.10406 15.4849 2.25 17.25 2.25C18.6424 2.25 19.9777 2.80312 20.9623 3.78769C21.9469 4.77226 22.5 6.10761 22.5 7.5C22.5 14.25 12 20.25 12 20.25Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    // Group variants by color
    if (colorOptionIndex !== -1) {
      const colors = product.options.find(o => o.position === colorOptionIndex).values;
      colors.forEach(color => {
        const cssColor = color.toLowerCase().replace(/ /g, '');
        html += `<div class="quick-add-color-group">`;
        html += `
          <div class="quick-add-color-header">
            <div class="quick-add-color-swatch" style="background-color: ${cssColor};"></div>
            <div class="quick-add-color-title">${color}</div>
          </div>
        `;
        html += `<div class="quick-add-variant-list">`;
        
        const colorVariants = product.variants.filter(v => v[`option${colorOptionIndex}`] === color);
        colorVariants.forEach(v => {
          const size = sizeOptionIndex !== -1 ? v[`option${sizeOptionIndex}`] : '';
          const avail = v.available && !forceSoldOut;
          const isLow = avail && lowIds.has(String(v.id));
          const statusText = avail ? (isLow ? '残りわずか' : '在庫あり') : 'SOLD OUT';
          const btnText = avail ? 'ADD TO BAG' : '再入荷通知';
          const btnClass = avail ? 'quick-add-variant-add' : 'quick-add-variant-add is-restock';
          const statusClass = avail ? (isLow ? 'quick-add-variant-status is-low' : 'quick-add-variant-status') : 'quick-add-variant-status is-sold-out';
          
          const isVWished = currentWishlist.some(item => String(item.variantId) === String(v.id));
          const vActiveClass = isVWished ? 'is-active' : '';

          html += `
            <div class="quick-add-variant-item">
              <div class="quick-add-variant-size-square">${size}</div>
              <div class="${statusClass}">${statusText}</div>
              <div class="quick-add-variant-actions">
                <button type="button" class="${btnClass}" data-variant-id="${v.id}" data-variant-title="${product.title} - ${v.title}">${btnText}</button>
                <button type="button" class="quick-add-wishlist-btn ${vActiveClass}"
                  data-wishlist-variant="${v.id}"
                  data-wishlist-handle="${product.handle}"
                  data-wishlist-title="${product.title} - ${v.title}">
                  ${heartSvg}
                </button>
              </div>
            </div>
          `;
        });

        html += `</div></div>`;
      });
    } else {
      html += `<div class="quick-add-variant-list">`;
      product.variants.forEach(v => {
        const title = v.title;
        const avail = v.available && !forceSoldOut;
        const isLow = avail && lowIds.has(String(v.id));
        const statusText = avail ? (isLow ? '残りわずか' : '在庫あり') : 'SOLD OUT';
        const btnText = avail ? 'ADD TO BAG' : '再入荷通知';
        const btnClass = avail ? 'quick-add-variant-add' : 'quick-add-variant-add is-restock';
        const statusClass = avail ? (isLow ? 'quick-add-variant-status is-low' : 'quick-add-variant-status') : 'quick-add-variant-status is-sold-out';

        const isVWished = currentWishlist.some(item => String(item.variantId) === String(v.id));
        const vActiveClass = isVWished ? 'is-active' : '';

        html += `
          <div class="quick-add-variant-item">
            <div class="quick-add-variant-size-square">${title}</div>
            <div class="${statusClass}">${statusText}</div>
            <div class="quick-add-variant-actions">
              <button type="button" class="${btnClass}" data-variant-id="${v.id}" data-variant-title="${product.title} - ${v.title}">${btnText}</button>
              <button type="button" class="quick-add-wishlist-btn ${vActiveClass}"
                data-wishlist-variant="${v.id}"
                data-wishlist-handle="${product.handle}"
                data-wishlist-title="${product.title} - ${v.title}">
                ${heartSvg}
              </button>
            </div>
          </div>
        `;
      });
      html += `</div>`;
    }

    html += `
      <div class="quick-add-notice">
        ※通常商品と予約商品の同時購入は可能ですが、全てのお品物が揃ってからの同梱での発送となります。予約商品の単発発送はできかねますので、ご了承ください。
      </div>
    `;

    quickAddInner.innerHTML = html;

    // Add to cart events
    quickAddInner.querySelectorAll('.quick-add-variant-add').forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.classList.contains('is-restock')) {
          const variantId = this.dataset.variantId;
          const variantTitle = this.dataset.variantTitle;
          sendRestockRequest(variantId, variantTitle, this);
        } else {
          const variantId = this.dataset.variantId;
          addToCart(variantId, this);
        }
      });
    });

    // Wishlist events（バリアント単位）— theme.js のイベント委譲が処理するため個別リスナー不要
  }

  function addToCart(variantId, btnElement) {
    const originalText = btnElement.textContent;
    btnElement.textContent = 'Adding...';
    btnElement.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => res.json())
    .then(data => {
      btnElement.textContent = 'Added';
      setTimeout(() => {
        btnElement.textContent = originalText;
        btnElement.disabled = false;
        closeQuickAdd();
        openCart(); // Show Cart Drawer
      }, 500);
    })
    .catch(err => {
      console.error(err);
      btnElement.textContent = 'Error';
      setTimeout(() => {
        btnElement.textContent = originalText;
        btnElement.disabled = false;
      }, 1000);
    });
  }

  function sendRestockRequest(variantId, variantTitle, btnElement) {
    const webhookUrl = window.__rell_restock_webhook || '';

    const email = '';

    const originalText = btnElement.textContent;
    btnElement.textContent = '送信中...';
    btnElement.disabled = true;

    // GAS webhook URLが設定されていればGASへ送信（スプレッドシートに記録）
    if (webhookUrl) {
      const productHandle = document.body.dataset.productHandle || '';
      const payload = {
        type: 'restock',
        product_title: variantTitle.split(' - ')[0] || variantTitle,
        product_handle: productHandle,
        product_url: window.location.origin + '/products/' + productHandle,
        variant_title: variantTitle,
        variant_id: variantId,
        customer_email: email,
        timestamp: new Date().toISOString()
      };

      fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload)
      })
      .then(() => {
        btnElement.textContent = '完了';
        alert("再入荷リクエストを受け付けました。");
        setTimeout(() => {
          btnElement.textContent = originalText;
          btnElement.disabled = false;
          closeQuickAdd();
        }, 1000);
      })
      .catch(() => {
        // no-corsモードではエラーでも送信成功していることが多い
        btnElement.textContent = '完了';
        alert("再入荷リクエストを受け付けました。");
        setTimeout(() => {
          btnElement.textContent = originalText;
          btnElement.disabled = false;
          closeQuickAdd();
        }, 1000);
      });
    } else {
      // フォールバック: Shopify /contact フォームへ送信
      const formData = new FormData();
      formData.append('form_type', 'contact');
      formData.append('utf8', '✓');
      formData.append('contact[email]', email);
      formData.append('contact[body]', `【再入荷通知リクエスト】\n商品名: ${variantTitle}\nバリアントID: ${variantId}\nお客様メール: ${email}`);

      fetch('/contact', {
        method: 'POST',
        body: formData
      })
      .then(() => {
        btnElement.textContent = '完了';
        alert("再入荷リクエストを受け付けました。");
        setTimeout(() => {
          btnElement.textContent = originalText;
          btnElement.disabled = false;
          closeQuickAdd();
        }, 1000);
      })
      .catch(err => {
        console.error(err);
        btnElement.textContent = 'エラー';
        alert("送信中にエラーが発生しました。");
        btnElement.disabled = false;
        btnElement.textContent = originalText;
      });
    }
  }

  // --- Cart Drawer Logic ---
  function fetchCart() {
    cartBody.innerHTML = '<div class="cart-drawer__loading" style="text-align: center; padding: 40px 0;">Loading...</div>';
    cartFooter.style.display = 'none';

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        renderCart(cart);
        updateHeaderCartCount(cart.item_count);
      })
      .catch(err => {
        console.error(err);
        cartBody.innerHTML = '<p style="text-align:center;">カート情報の取得に失敗しました。</p>';
      });
  }

  function renderCart(cart) {
    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div class="cart-drawer__empty" style="text-align: center; padding: 40px 0;">
          <p>カートに商品がありません。</p>
          <button type="button" class="cart-drawer__empty-btn" data-cart-close style="display:inline-block; margin-top:20px; padding:10px 20px; background:#1a1a1a; color:#fff; border:none; cursor:pointer;">お買い物を続ける</button>
        </div>
      `;
      cartFooter.style.display = 'none';
      return;
    }

    let html = '<div class="cart-drawer__items">';
    cart.items.forEach(item => {
      const imgUrl = item.image ? item.image : '';
      const price = moneyFormat(item.original_price);
      
      // Parse Color and Size from variant title (e.g. "PNK / S")
      let color = '';
      let size = '';
      if (item.variant_title) {
        const parts = item.variant_title.split(' / ');
        if (parts.length === 2) {
          color = parts[0];
          size = parts[1];
        } else {
          color = item.variant_title;
        }
      }

      html += `
        <div class="cart-drawer__item" data-key="${item.key}">
          <div class="cart-drawer__item-img">
            <img src="${imgUrl}" alt="${item.title}">
          </div>
          <div class="cart-drawer__item-info">
            <div class="cart-drawer__item-title">${item.product_title}</div>
            ${color ? `<div class="cart-drawer__item-variant">色：${color}</div>` : ''}
            ${size ? `<div class="cart-drawer__item-variant">サイズ：${size}</div>` : ''}
            <div class="cart-drawer__item-price">${price}</div>
            
            <div class="cart-drawer__item-actions">
              <div class="cart-drawer__qty">
                <button type="button" class="cart-drawer__qty-btn" data-action="minus" data-key="${item.key}">−</button>
                <input type="number" class="cart-drawer__qty-input" value="${item.quantity}" readonly>
                <button type="button" class="cart-drawer__qty-btn" data-action="plus" data-key="${item.key}">＋</button>
              </div>
              <button type="button" class="cart-drawer__remove" data-key="${item.key}">削除</button>
            </div>
          </div>
        </div>
      `;
    });
    html += '</div>';

    cartBody.innerHTML = html;
    cartTotal.textContent = moneyFormat(cart.total_price);
    
    // Free shipping calculation (threshold: 10,000 yen)
    const threshold = 1000000; // in cents
    const shippingMsg = document.getElementById('CartDrawerShippingMessage');
    if (cart.total_price < threshold) {
      const remaining = threshold - cart.total_price;
      shippingMsg.innerHTML = `あと、${(remaining/100).toLocaleString()}円で送料無料`;
    } else {
      shippingMsg.innerHTML = `送料無料が適用されました`;
    }

    cartFooter.style.display = 'block';

    // Re-attach close event for "Continue Shopping" button in footer
    const continueBtn = cartFooter.querySelector('.cart-drawer__continue-btn');
    if (continueBtn) continueBtn.addEventListener('click', closeCart);

    // Attach events
    cartBody.querySelectorAll('.cart-drawer__qty-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.key;
        const action = this.dataset.action;
        const input = this.parentElement.querySelector('.cart-drawer__qty-input');
        let qty = parseInt(input.value);
        if (action === 'plus') qty++;
        else if (action === 'minus') qty--;
        updateCartItem(key, qty);
      });
    });

    cartBody.querySelectorAll('.cart-drawer__remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.dataset.key;
        updateCartItem(key, 0);
      });
    });
  }

  function updateCartItem(key, qty) {
    cartBody.innerHTML = '<div class="cart-drawer__loading" style="text-align: center; padding: 40px 0;">Updating...</div>';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty
      })
    })
    .then(res => res.json())
    .then(cart => {
      renderCart(cart);
      updateHeaderCartCount(cart.item_count);
    })
    .catch(err => {
      console.error(err);
      fetchCart();
    });
  }

  function updateHeaderCartCount(count) {
    const badge = document.querySelector('.site-header__cart-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }
});
